module.exports = __webpack_public_path__ + "static/chp-web-1-301f8e82034b23f0c21249cac24f7da0.jpg";